"use client";

import { createIcon } from "@chakra-ui/react";

const ChevronRightSvgIcon = createIcon({
  displayName: "ChevronRightSvgIcon",
  viewBox: "0 0 20 20",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M5.83203 15.1966L10.832 10.1966L5.83203 5.19662L7.4987 3.52995L14.1654 10.1966L7.4987 16.8633L5.83203 15.1966Z" fill="currentColor"/>
  ),
});

export default ChevronRightSvgIcon;
